/**
 * @file 首页
 * @author gaojie15
 */

import {INQUEIRY_LOGIN, INQUEIRY_LOHOUT} from '../actions/ActionTypes';

export function inquiry(state = {}, action) {
    switch (action.type) {
        case INQUEIRY_LOGIN:
            if (action.data) {
                state = action.data;
                return state;
            }
            return {};
        case INQUEIRY_LOHOUT:
            state = {};
            return {};
        default:
            return state;
    }
}
